import React, { Fragment, useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
import Router from "next/router";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import CryptoJS from "crypto-js";
import Drawer from "@mui/material/Drawer";
import ModalTitle from "../../components/modals/ticketModal/title";
import ModalInfo from "../../components/modals/ticketModal/info";
import ModalTicketContainer from "../../components/modals/ticketModal/ticketContainer";
import ModalCheckOutContainer from "../../components/modals/ticketModal/checkoutContainer";
import Cookies from "js-cookie";
import Dialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CircularTable from "../../public/images/circularTable.png";
import Link from "next/link";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Image from "next/image";
import { useAppContext } from "../../AppContext";
import { useTheme } from "@mui/material/styles";

function TicketsModal(props) {
  const { open, onClose, onCloseAlert } = props;
  const [openAlert, setOpenAlert] = useState(false);
  const [openAlert1, setOpenAlert1] = useState(false);
  let [eventsInner, setEventsInner] = useState(props.event);
  let [tickets, setTickets] = useState(props.tickets);
  let [eventArray, setEventArray] = useState([]);
  let [eventTickets, setEventTickets] = useState(props.tickets);
  let [eventTicketsHidden, setEventTicketsHidden] = useState(props.tickets);
  let [totalCost, setTotalCost] = useState(0);
  let [totalNoOfTickets, setTotalNoOfTickets] = useState(0);
  let [showTickets, setShowTickets] = useState(false);
  const TICKET_TITLE_MAX_LENGTH = 35;
  const [uniqueId, setUniqueId] = useState(props.uniqueId);

  const [showReserveTablesButton, setShowReserveTablesButton] = useState(false);

  const theme = useTheme();
  const {
    url,
    themeData,
    siteData,
    themeLoading,
    siteLoading,
    themeError,
    siteError,
    changeUrl,
    updateThemeData,
    updateSiteData,
  } = useAppContext();
  const [themeCss, setThemeCss] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let custom_css =
      themeData && themeData
        ? JSON.parse(themeData && themeData.custom_css)
        : null;
    setThemeCss(custom_css);
    setLoading(false);
  }, [themeData]);

  const closeIconStyle = {
    fontSize: 18,
    color: theme.palette.primary.contrastText,
    mx: 1,
    cursor: "pointer",
  };

  const ticketsModal = {
    background: theme.palette.background.default,
    paddingTop: 0,
    h3: {
      fontSize: 14,
      fontFamily:
        themeCss && themeCss.theme_primary_font
          ? themeCss.theme_primary_font.replace("+", " ")
          : "",
      fontWeight: 100,
      color: theme.palette.primary.contrastText,
      textTransform: "capitalize",
      marginTop: theme.spacing(2),
      marginTop: theme.spacing(1),
    },
  };

  useEffect(() => {
    setUniqueId(props.uniqueId);
  }, [props.uniqueId]);

  const encrypt = (text) => {
    return CryptoJS.AES.encrypt(text, process.env.ENCRYPTION_KEY).toString();
  };

  const decrypt = (encryptedText) => {
    const bytes = CryptoJS.AES.decrypt(
      encryptedText,
      process.env.ENCRYPTION_KEY
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  useEffect(() => {
    setEventsInner(props.event);
    axios
      .get(`/api/events/checkTablesTaggedToEvent?eventId=${props.event.id}`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((resp) => {
        setShowReserveTablesButton(resp.data);
      })
      .catch((err) => {
        setShowReserveTablesButton(false);
      });
  }, [props]);

  const eventCounterIncrease = (e) => {
    e.preventDefault();
    let eventIndex = parseInt(e.target.getAttribute("data-event-id"));
    let x = props.tickets[eventIndex].numberOfTickets + 1;
    let y = props.tickets[eventIndex].available_qty;
    if (props.tickets[eventIndex].numberOfTickets <= 19 && x <= y) {
      props.tickets[eventIndex].numberOfTickets += 1;
      totalCost += parseInt(props.tickets[eventIndex].price);
      totalNoOfTickets += 1;
      evaluateCartArray();
      setEventTickets(props.tickets);
      setTotalCost(totalCost);
      setTotalNoOfTickets(totalNoOfTickets);
    } else {
      toast.error(
        "Tickets At Limit Organiser/ Venue has set a ticket limit of 20 per account.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
    }
  };

  const eventCounterDecrease = (e) => {
    e.preventDefault();
    let eventIndex = parseInt(e.target.getAttribute("data-event-id"));
    if (props.tickets[eventIndex].numberOfTickets > 0) {
      props.tickets[eventIndex].numberOfTickets -= 1;
      totalCost -= parseInt(props.tickets[eventIndex].price);
      totalNoOfTickets -= 1;
      evaluateCartArray();
      setEventTickets(props.tickets);
      setTotalCost(totalCost);
      setTotalNoOfTickets(totalNoOfTickets);
    }
  };

  function evaluateCartArray() {
    let eventArray = [];
    for (let i = 0; i < props.tickets.length; i++) {
      if (props.tickets[i].numberOfTickets > 0) {
        eventArray.push({
          id: props.tickets[i].id,
          type: props.tickets[i].type,
          title: props.tickets[i].title,
          numberOfTickets: props.tickets[i].numberOfTickets,
          persons: props.tickets[i].persons,
          price: props.tickets[i].price,
          end_time: props.tickets[i].end_time,
          eventTitle: eventsInner.title,
          booking_fee_payer: props.tickets[i].booking_fee_payer,
          payment_gateway_fee_payer: props.tickets[i].payment_gateway_fee_payer,
          booking_fee: props.tickets[i].booking_fee,
          payment_gateway_fee: props.tickets[i].payment_gateway_fee,
          money_to_you: props.tickets[i].money_to_you,
          total_paid_by_buyer: props.tickets[i].total_paid_by_buyer,
          price_gst: props.tickets[i].price_gst
            ? props.tickets[i].price_gst
            : 0,
          gst_type: props.tickets[i].gst_type ? props.tickets[i].gst_type : 1,
        });
      }
    }
    setEventTickets(props.tickets);
    setEventArray(eventArray);
  }

  async function onPageRedirect(e) {
    e.preventDefault();
    setLoading(true);
    uniqueId != null &&
      uniqueId != "" &&
      sessionStorage.setItem("affiliateUniqueId", uniqueId);
    let tickets = JSON.stringify(eventArray);
    let event_id = eventsInner.id;
    let club_id = eventsInner.clubId;

    let new_data = {};
    new_data.tickets = tickets;
    new_data.identity_id = event_id;
    new_data.club_id = club_id;
    new_data.cart_type = "events";
    // new_data.identity_details = props.event;
    new_data.identity_details = {
      id: props.event.id ?? "",
      slug: props.event.slug ?? "",
      title: props.event.title ?? "",
      event_type: props.event.event_type ?? "",
      clubName: props.event.clubName ?? "",
      area_name: props.event.area_name ?? "",
      cityName: props.event.cityName ?? "",
      only_today: props.event.only_today ?? "",
      start_time: props.event.start_time ?? "",
      from_date: props.event.from_date ?? "",
      to_date: props.event.to_date ?? "",
      event_venue: props.event.event_venue ?? "",
    };

    sessionStorage.setItem("cart", encrypt(JSON.stringify(new_data)));
    sessionStorage.setItem("ct", encrypt(`${new Date().getTime()}`));

    await axios
      .post(
        `/api/innerPage/saveCartData`,
        {
          data: encrypt(JSON.stringify(new_data)),
        },
        {
          headers: {
            "x-auth-token": process.env.JWT_TOKEN,
          },
        }
      )
      .then(async (response) => {
        const decrypted = JSON.parse(decrypt(response.data.data));
        if (response.status == 200) {
          if (decrypted.token) {
            // console.log(decrypted.token);
            let cart_id = decrypted.token;
            // Cookies.set("ctoken", cart_id);
            // setTimeout(() => {
            // console.log('redirecting............');
            Router.push({ pathname: "/cart/" + cart_id });
            setLoading(false);
            // }, 3000);
            // window.location.href = "/cart/"+cart_id
          } else {
            setLoading(false);
            toast.error("Something went wrong, please reload then try", {
              position: toast.POSITION.BOTTOM_CENTER,
            });
          }
        } else if (response.status == 201) {
          let newResponse = JSON.parse(decrypted.soldOutTickets);
          setLoading(false);
          for (let i = 0; i < newResponse.length; i++) {
            toast.error(newResponse[i].title + " is SoldOut", {
              position: toast.POSITION.BOTTOM_CENTER,
            });
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status == 406) {
            setLoading(false);
            toast.error("Something went wrong, please reload then try", {
              position: toast.POSITION.BOTTOM_CENTER,
            });
          }
        }
      });
  }

  const emptyBeforeClose = () => {
    setOpenAlert(true);
  };

  const closeAlertDialog = () => {
    setOpenAlert(false);
  };

  // const closeAlertDialog1 = () => {
  //   setOpenAlert1(false);
  //   window.history.pushState("/", "");
  //   Router.push(Router.asPath);
  // };

  // const clickYes = (e) => {
  //   e.preventDefault();
  //   setOpenAlert1(false)
  //   Router.push('/events')
  // };

  const removeSelectedTickets = (e) => {
    e.preventDefault();

    const emptyArray = [];
    setEventTickets(props.ticketsHidden);
    setEventArray(emptyArray);
    setTotalCost(0);
    setOpenAlert(false);
    setTotalNoOfTickets(0);

    for (let i = 0; i < props.tickets.length; i++) {
      props.tickets[i].numberOfTickets = 0;
    }
    onCloseAlert();
  };

  // const removeSelectedTickets1 = (e) => {
  //   e.preventDefault();

  //   const emptyArray = [];
  //   setEventTickets(props.ticketsHidden);
  //   setEventArray(emptyArray);
  //   setTotalCost(0);
  //   setOpenAlert1(false);
  //   setTotalNoOfTickets(0);

  //   for (let i = 0; i < props.tickets.length; i++) {
  //     props.tickets[i].numberOfTickets = 0;
  //   }
  //   onCloseAlert1();
  //   setOpenAlert1(false)
  //   Router.push('/events')
  // };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 350,
    bgcolor: theme.palette.background.alternate,
    border: `1px solid ${theme.palette.background.borderColor}`,
    boxShadow: 24,
    p: 3,
    borderRadius: 2,
    color: theme.palette.primary.contrastText,
    height: 270,
    "& h3": {
      fontSize: 22,
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontWeight: 700,
      color: theme.palette.primary.contrastText,
    },
    "& h5": {
      fontSize: 16,
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontWeight: 500,
      color: theme.palette.primary.contrastText,
    },
  };

  const muiDrawer = {
    // width: '36%',
    "& .MuiDrawer-paper": {
      background: theme.palette.background.default,
      borderLeft: `1px solid ${theme.palette.background.borderColor}`,
      maxWidth: "36%",
      width: "36%",
      paddingBottom: theme.spacing(12),
      [theme.breakpoints.down("md")]: {
        width: "100%",
        maxWidth: "100%",
        borderLeft: "none",
      },
    },
  };

  const gotoTables = (event) => {
    event.preventDefault();
    setLoading(true);
    Router.push(`/tables/${props.event.slug}/${props.event.id}`, undefined, {
      shallow: true,
    });
  };

  return (
    <Fragment>
      <Dialog
        fullScreen
        open={openAlert}
        onClose={closeAlertDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          backdropFilter: "blur(5px)",
          "& .MuiDialog-paper": {
            background: "unset !important",
          },
        }}
      >
        <DialogContent>
          <Box sx={style}>
            <Stack
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              alignItems="start"
            >
              <Typography component="div" onClick={closeAlertDialog}>
                <CloseIcon sx={closeIconStyle} />
              </Typography>
            </Stack>
            <Stack
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="baseline"
            >
              <Typography
                component="div"
                sx={{
                  background: theme.palette.background.default,
                  padding: "10px",
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  mr: 1,
                  textAlign: "center",
                }}
              >
                <WarningAmberIcon sx={{ fontSize: 18 }} />
              </Typography>
              <Typography id="modal-modal-title" variant="h3">
                Are you sure ?
              </Typography>
            </Stack>
            <Typography
              variant="h5"
              id="modal-modal-description"
              sx={{
                mb: 4,
                mt: 2,
                color: "#ffffff90",
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              All Selected Ticket(s) will be Removed
            </Typography>
            <Typography
              component="div"
              sx={{ mt: 4, justifyContent: "center", display: "flex" }}
            >
              <Button
                variant="contained"
                onClick={removeSelectedTickets}
                className="themeBtn"
                sx={{
                  fontWeight: 500,
                  color: theme.palette.background.default,
                  "&.themeBtn": {
                    fontFamily:
                      themeCss && themeCss.theme_body_font
                        ? themeCss.theme_body_font.replace("+", " ")
                        : "",
                    background: `${
                      themeCss && themeCss.theme_main_color
                    } !important`,
                    // border:`2px solid ${themeCss&&themeCss.theme_main_color}`,
                    color: `${
                      themeCss && themeCss.theme_primary_font_color
                    } !important`,
                  },
                }}
              >
                Confirm
              </Button>
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        ModalProps={{
          keepMounted: true,
        }}
        hideBackdrop={true}
        sx={{
          ...muiDrawer,
          backdropFilter: "blur(5px)",
        }}
      >
        <Box sx={ticketsModal}>
          <ModalTitle
            data={props.event}
            totalNoOfTickets={totalNoOfTickets}
            onClose={onClose}
            emptyBeforeClose={emptyBeforeClose}
          />
          {showReserveTablesButton && (
            <Typography
              component="div"
              sx={{ px: 4, mt: 3 }}
              onClick={(e) => gotoTables(e)}
            >
              <Stack
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  background: `${
                    themeCss && themeCss.theme_main_color
                  } !important`,
                  p: 1.5,
                  borderRadius: theme.spacing(1),
                }}
              >
                <Stack
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  sx={{ width: "100%" }}
                >
                  <Image src={CircularTable} alt="..." height="40" width="40" />
                  <Typography
                    variant="h5"
                    sx={{
                      ml: 4,
                      fontWeight: 500,
                      fontSize: 16,
                      color: theme.palette.background.default,
                    }}
                  >
                    Book Your Table
                  </Typography>
                </Stack>
                <Typography
                  component="div"
                  sx={{ cursor: "pointer" }}
                  onClick={(e) => gotoTables(e)}
                >
                  <span
                    className="rippleBtnAlt"
                    style={{
                      padding: "10px 0px",
                      display: "flex",
                      alignItems: "center",
                      color: theme.palette.background.default,
                    }}
                  >
                    <span>
                      <ArrowForwardIcon
                        sx={{
                          fontSize: "14px",
                          color: `${
                            themeCss && themeCss.theme_main_color
                          } !important`,
                          zIndex: 3,
                        }}
                      />
                    </span>
                  </span>
                </Typography>
              </Stack>
            </Typography>
          )}
          <Typography component="div" sx={{ px: 4 }}>
            <Typography variant="h3" sx={{ py: 2 }}>
              Tickets
            </Typography>
            {props.tickets.length > 0 && (
              <Typography component="div">
                {props.tickets.map((ticket, i) => (
                  <ModalTicketContainer
                    index={i}
                    key={i}
                    ticket={ticket}
                    eventCounterIncrease={eventCounterIncrease}
                    eventCounterDecrease={eventCounterDecrease}
                  />
                ))}
              </Typography>
            )}
            <ModalInfo />
          </Typography>
        </Box>
        <Typography component="div" sx={{ position: "relative" }}>
          {eventArray.length > 0 && (
            <ModalCheckOutContainer
              totalCost={totalCost}
              totalNoOfTickets={totalNoOfTickets}
              onPageRedirect={onPageRedirect}
            />
          )}
        </Typography>
      </Drawer>
    </Fragment>
  );
}

export default TicketsModal;
